import { render, staticRenderFns } from "./Circus.vue?vue&type=template&id=9f53d16a&scoped=true"
import script from "./Circus.vue?vue&type=script&lang=js"
export * from "./Circus.vue?vue&type=script&lang=js"
import style0 from "./Circus.vue?vue&type=style&index=0&id=9f53d16a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f53d16a",
  null
  
)

export default component.exports